import { Header } from "./Components/Header/header";
import { Header1 } from "./Components/Header/header_1";
import { Navbar } from "./Components/Navbar/navbar";

import { Home } from "./Components/Home/Home";

import { About } from "./Components/About/about";

import { Organizing } from "./Components/Committees/organizing";
import { Steering } from "./Components/Committees/steering";
import { Supporting } from "./Components/Committees/supporting";
import { Technical } from "./Components/Committees/technical";

import { CallforPapers } from "./Components/Submission/papers";
import { CallforSponsors } from "./Components/Submission/sponsors";
import { CallforSpeakers } from "./Components/Submission/speakers";
import { CallforWorkshop } from "./Components/Submission/workshops";
import { CallforTutorial } from "./Components/Submission/tutorial";

import { Program } from "./Components/Program/program";
import { ImportantDates } from "./Components/Program/importantDates";
import { PlenaryAndKeynoteSpeakers } from "./Components/Program/plenaryAndKeynoteSpeakers";
import { InvitedSpeakers } from "./Components/Program/invitedSpeakers";
import { SpecialSessions } from "./Components/Program/specialSessions";
import { Workshop } from "./Components/Program/workshops";
import { Tutorial } from "./Components/Program/tutorial";
import { GraduateForum } from "./Components/Program/graduateForum";
import { TopicalSpeakers } from "./Components/Program/topicalSpeakers";

import { Visa } from "./Components/Registration/visa";
import { Awards } from "./Components/Registration/awards";
import { IHCITravelGrant } from "./Components/Registration/ihciTravelGrant";
import { PaymentandFees } from "./Components/Registration/paymentandFees";

import { Footer } from "./Components/Footer/Footer";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() { 
  return (
    <>
      <Router>
        <Header/>
        <Header1/>
        <Routes>
          <Route exact path= "/" element={<Home/>} ></Route>
          <Route exact path= "/ihci-2023" element={<><Navbar pagename = "IHCI SOCIETY" link="/ihci-2023"/><About/></>} ></Route>

          <Route exact path= "/committees/organizing" element={<><Navbar pagename = "Organizing Committees"link="/committees/organizing"/><Organizing/></>} ></Route>
          <Route exact path= "/committees/steer ing" element={<><Navbar pagename = "Steering Committees" link="/committees/steering"/><Steering/></>} ></Route>
          <Route exact path= "/committees/supporting" element={<><Navbar pagename = "Supporting Committees" link="/committees/supporting"/><Supporting/></>} ></Route>
          <Route exact path= "/committees/technical" element={<><Navbar pagename = "Technical Committees" link="/committees/technical"/><Technical/></>} ></Route>

          <Route exact path= "/submission/call for papers" element={<><Navbar pagename = "Call for Papers" link="/submission/call for papers"/><CallforPapers/></>} ></Route>
          <Route exact path= "/submission/call for sponsors" element={<><Navbar pagename = "Call for Sponsors" link="/submission/call for sponsors"/><CallforSponsors/></>} ></Route>
          <Route exact path= "/submission/call for speakers" element={<><Navbar pagename = "Call for Speakers" link="/submission/call for speakers"/><CallforSpeakers/></>} ></Route>
          <Route exact path= "/submission/call for workshop" element={<><Navbar pagename = "Call for Workshop" link = "/submission/call for workshop"/><CallforWorkshop/></>} ></Route>
          <Route exact path= "/submission/call for tutorial" element={<><Navbar pagename = "Call for Tutorial" link="/submission/call for tutorial"/><CallforTutorial/></>} ></Route>
          
          <Route exact path= "/program/program" element={<><Navbar pagename = "Program" link="/program/program"/><Program/></>} ></Route>
          <Route exact path= "/program/important-dates" element={<><Navbar pagename = "Important Dates" link="/program/important-dates"/><ImportantDates/></>} ></Route>
          <Route exact path= "/program/plenary and keynote speakers" element={<><Navbar pagename = "Plenary and Keynote Speakers" link="/program/plenary-and-keynote-speakers" /><PlenaryAndKeynoteSpeakers/></>} ></Route>
          <Route exact path= "/program/invited speakers" element={<><Navbar pagename = "Invited Speakers" link="/program/invited speakers"/><InvitedSpeakers/></>} ></Route>
          <Route exact path= "/program/special sessions" element={<><Navbar pagename = "Special Sessions" link="/program/special sessions"/><SpecialSessions/></>} ></Route>
          <Route exact path= "/program/workshop" element={<><Navbar pagename = "Workshop" link="/program/workshop"/><Workshop/></>} ></Route>
          <Route exact path= "/program/tutorial" element={<><Navbar pagename = "Tutorial" link="/program/tutorial"/><Tutorial/></>} ></Route>
          <Route exact path= "/program/graduate forum" element={<><Navbar pagename = "Graduate Forum" link= "/program/graduate forum"/><GraduateForum/></>} ></Route>
          <Route exact path= "/program/topical speakers" element={<><Navbar pagename = "Topical Speakers" link="/program/topical speakers"/><TopicalSpeakers/></>} ></Route>

          <Route exact path= "/registration/visa" element={<><Navbar pagename = "Visa" link="/registration/visa"/><Visa/></>} ></Route>
          <Route exact path= "/registration/awards" element={<><Navbar pagename = "Awards" link="/registration/awards"/><Awards/></>} ></Route>
          <Route exact path= "/registration/ihci travel grant" element={<><Navbar pagename = "IHCI Travel Grant" link="/registration/ihci travel grant"/><IHCITravelGrant/></>} ></Route>
          <Route exact path= "/registration/payment and fees" element={<><Navbar pagename = "Payment and fees" link="/registration/payment and fees"/><PaymentandFees/></>} ></Route>
        </Routes>
        <Footer/>
      </Router>
    </>
  );
}

export default App;